import axios from "axios";

// Thin client for the website's own pricing proxy. The CASS keys live on our
// backend only — nothing here knows a rate, a rule or a price.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SID_KEY = "cass_package_sid";

export function packageSessionId() {
  let id = localStorage.getItem(SID_KEY);
  if (!id) {
    id = window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SID_KEY, id);
  }
  return id;
}

const client = axios.create({ baseURL: `${BACKEND_URL}/api/pricing` });
client.interceptors.request.use((config) => {
  // CASS rate-limits per session, so one busy visitor can't exhaust another's budget.
  config.headers["X-CASS-Session"] = packageSessionId();
  return config;
});

export const packageApi = {
  catalogue: () => client.get("/catalogue").then((r) => r.data),
  quote: (body) => client.post("/quote", body).then((r) => r.data),
  enquiry: (body) => client.post("/enquiry", body).then((r) => r.data),
  // Where they've got to. Anonymous, best-effort — a failure never interrupts the journey.
  progress: (body) => client.post("/progress", body).catch(() => {}),
};
